<template>
	<van-swipe class="my-swipe" :autoplay="3000" lazy-render :style="stylen.show">
	  <van-swipe-item v-for="image in images" :key="image">
	    <img :src="image.img" @click="gotohref(image.href)"/>
	  </van-swipe-item>
	</van-swipe>
</template>

<script>
	import axios from 'axios'
	import { getCurrentInstance,inject,reactive,ref } from 'vue'
	export default{
		name:'Slider',
		setup(){
			const images = ref([]);
			const baseurl = getCurrentInstance().appContext.config.globalProperties.axiosurl
			const { lotid } = inject('lottery')
			let stylen = reactive({
				show:''
			})
			const getslide = async()=>{
				let accessData = {
					"serviceName":"zjtjIndexService",
					"methodName":"getAllCarouseImage",
					"parameters":{
						"sid": "36001800018",
						"type": 38,
						"lyClassCode":'300'
					}
				}
				accessData = JSON.stringify(accessData)
				const { data:{result} } = await axios.post(`${baseurl}/api/zjtj.action?accessSecretData=${accessData}`)
				if(result.length==0){
					stylen.show={display:'none'}
				}else{
					images.value = result.map((v,i)=>{
						let obj = {
							img:v.imgUrl,
							href:v.linkUrl||'javascript:void(0)'
						}
						return obj
					})
				}
			}
			const gotohref = (href) => {
				window.parent.location.href = href
			}
			getslide()
			return { images,stylen,gotohref }
		}
	}
</script>

<style scoped="scoped">
	.my-swipe .van-swipe-item {
	    width:100%;
		height:100%;
	}
</style>
